import React, { useState, useEffect } from 'react';
import { Link, useHistory } from "react-router-dom";
import Strings from  '../common/Strings';
import { StateArray } from '../common/Constants';
import { patternMessage, invalidInputStyle, selectOptions, checkboxMessage } from '../common/Forms';

import { getAccountsApiUrl, apiGet, apiPost } from '../common/AppApi';
import Processing from '../common/Processing';
import MessageTag from '../common/MessageTag';
import MessageTag2 from '../common/MessageTag';
import { decodeValues, formatPhone } from '../common/Formats'

export default function CTApplication() {
    let blankApplicant = {
        firstname:'',
        lastname:'',
        middlename:'',
        address1:'',
        address2:'',
        city:'',
        stateId:'',
        zipcode:'',
        email:'',
        mobilePhone:''
    };
    
    let [applicant, setApplicant] = useState(blankApplicant);
    let [screen, setScreen] = useState(-1);
    let [applicantion, setApplication] = useState({name:'',descr:''});
    let [program, setProgram] = useState({programId:null, programUuid:'', programName:'', shortName:''});

    let [showSpinner, setSpinner] = useState(false);
    let [message, setMessage] = useState();
    let [message2, setMessage2] = useState();

	let handleFieldChange = (event) => {
		const {id, value} = event.target;
		let cloned = {...applicant, [id]:value};
		setApplicant(cloned);
	}

    let stopSpinner = () => {
        setSpinner(false);
    };

    let handleNextScreen = (e) => {
        e.preventDefault();
        setScreen(screen + 1);
    };
    let previousScreen = () => {
        setScreen(screen - 1);
    };

    let getApplInfo = () => {
        let success = (resp) => {
            //console.debug(resp);

            if (resp) {
                setApplication(resp);
                if (resp && resp.active == true && resp.programs && resp.programs.length) {
                    setProgram(resp.programs[0])
                    setScreen(1);
                } else {
                    setMessage({text:Strings.warning.onlineAppUnavailable, type:'warning'});
                }
            } else {
                setMessage({text:Strings.warning.onlineAppUnavailable, type:'warning'});
            }

        };
        let fail = (resp) => {
            console.error(resp);
            setMessage({text:Strings.warning.onlineAppUnavailable, type:'warning'});
        };

        setSpinner(true);

        apiGet(getAccountsApiUrl() + '/application/1')
        .then(success)
        .catch(fail)
        .finally(stopSpinner);
    }

    let handleSubmit = (e) => {
        e.preventDefault();
        console.debug('submit to backend');

        setSpinner(true);

        let body = {...applicant, programId:program.programId};

        apiPost(getAccountsApiUrl() + '/applicant', body).then( (resp) => {
            //console.debug(resp);
            setScreen(screen + 1);
        }).catch( (error) => {
            console.debug(error);
            setMessage2({text:"The application cannot be submitted at this time.", type:'danger'});
        })
        .finally(stopSpinner);
    };

    useEffect( () => {

        getApplInfo();
    }, []);

    let btnMargin = {marginRight:'.2em'};

    let doMarkup = () => {
        return {__html: applicantion.descr};
    };

    if (screen == 1) {
		patternMessage("#zipcode", Strings.validation.zipFormat);
		patternMessage("#mobilePhone", Strings.validation.phoneFormat);
		patternMessage("#email", Strings.validation.emailFormat);

        return (
            <div className="container">
                <h3>{applicantion.name}</h3>
                <p dangerouslySetInnerHTML={doMarkup()}></p>

                <form onSubmit={handleNextScreen}>
                    <div className="row">
                        <div className="form-group required col-12 col-sm-5">
                            <label className="asterisk-label" htmlFor="firstname">First Name</label>
                            <input type="text" id="firstname" className="form-control" onChange={handleFieldChange} value={applicant.firstname} required maxLength="100" />
                        </div>
                        <div className="form-group col-12 col-sm-2">
                            <label htmlFor="middlename">Middle Initial</label>
                            <input type="text" id="middlename" className="form-control" onChange={handleFieldChange} value={applicant.middlename} maxLength="1" />
                        </div>
                        <div className="form-group required col-12 col-sm-5">
                            <label className="asterisk-label" htmlFor="lastname">Last Name</label>
                            <input type="text" id="lastname" className="form-control" onChange={handleFieldChange} value={applicant.lastname} required maxLength="100" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group required col-12 col-sm-6">
                            <label className="asterisk-label" htmlFor="address1">Address Line One</label>
                            <input type="text" id="address1" className="form-control" onChange={handleFieldChange} value={applicant.address1} required maxLength="60" />
                        </div>
                        <div className="form-group col-12 col-sm-6">
                            <label htmlFor="address2">Address Line Two</label>
                            <input type="text" id="address2" className="form-control" onChange={handleFieldChange} value={applicant.address2} maxLength="60"/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group required col-12 col-sm-6">
                            <label className="asterisk-label" htmlFor="addr1">City</label>
                            <input type="text" id="city" className="form-control" onChange={handleFieldChange} value={applicant.city} required maxLength="60" />
                        </div>
                        <div className="form-group required col-12 col-sm-6">
                            <label className="asterisk-label" htmlFor="stateId">State</label>
                            <select id="stateId" className="form-control custom-select" value={applicant.stateId} onChange={handleFieldChange} required >
                                { selectOptions(StateArray, 'id2') }
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group required col-12 col-sm-6">
                            <label className="asterisk-label" htmlFor="zipcode">Zip Code</label>
                            <input type="text" id="zipcode" className="form-control" onChange={handleFieldChange} value={applicant.zipcode} required maxLength="10" pattern="(\d{5}([\-]\d{4})?)" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group required col-12 col-sm-6">
                            <label className="asterisk-label" htmlFor="email">Email</label>
                            <input type="email" id="email" className="form-control" onChange={handleFieldChange} value={applicant.email} required maxLength="255" pattern={Strings.pattern.email}/>
                        </div>
                        <div className="form-group required col-12 col-sm-6">
                            <label className="asterisk-label" htmlFor="mobilePhone">Mobile Phone</label>
                            <input type="text" id="mobilePhone" className="form-control" onChange={handleFieldChange} value={applicant.mobilePhone} required maxLength="20" pattern={Strings.pattern.phone} />
                        </div>
                    </div>
                    <button className="btn btn-primary" id="btnReview" disabled={program.programId==null}>Review Application</button>
                </form>
            </div>
        );
    } else if (screen == 2) {
        return <div className='container'>
                <h3>{applicantion.name}</h3>
                <h4>Applicant Information</h4>
                <p>Please review the information that you have provided before continuing with the application.</p>
                <table className='table table-bordered'>
                <tbody>
                    <tr>
                        <th>First Name</th>
                        <td>{applicant.firstname}</td>
                        <th>Middle Name</th>
                        <td>{applicant.middlename}</td>
                        <th>Last Name</th>
                        <td>{applicant.lastname}</td>
                    </tr>
                    <tr>
                        <th>Address Line One</th>
                        <td colSpan={5}>{applicant.address1}</td>
                    </tr>
                    <tr>
                        <th>Address Line Two</th>
                        <td colSpan={5}>{applicant.address2}</td>
                    </tr>
                    <tr>
                        <th>City</th>
                        <td>{applicant.city}</td>
                        <th>State</th>
                        <td>{decodeValues(applicant.stateId, StateArray, 'id2')}</td>
                        <th>Zip Code</th>
                        <td>{applicant.zipcode}</td>
                    </tr>
                    <tr>
                        <th>Email</th>
                        <td colSpan={2}>{applicant.email}</td>
                        <th>Mobile Phone</th>
                        <td>{formatPhone(applicant.mobilePhone)}</td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
            <button className="btn btn-primary" type='button' style={btnMargin} onClick={previousScreen} id="btnEdit">Edit Application</button>
            <button className="btn btn-primary" type='button' style={btnMargin} onClick={handleNextScreen} id="btnContinue">Continue With Application</button>
        </div>
    } else if (screen == 3) {
        let checkboxMessage = (e) => {
            let myMsg = '';
            if (e.target.validity.valueMissing)
                myMsg = 'You must agree to the above statements to submit the application.';
            e.target.setCustomValidity(myMsg);
        };
        let checkBoxStyle = {accentColor: '#56CC9D', transform:'scale(1.4)'};
        return <div className='container'>
            <h3>{applicantion.name}</h3>
            <h4>Applicant Agreement</h4>
            <br/>
            <Processing show={showSpinner}/>
            <strong>Participant Rights & Responsibility</strong>
            <p>I have been advised of my rights and obligations under the SFMNP. I certify that the information I have
                 provided for my eligibility determination is correct, to the best of my knowledge.
                 This certification form is being submitted in connection with the receipt of Federal assistance.
                 Program officials may verify information on this form. I understand that intentionally making a false
                 or misleading statement or intentionally misrepresenting, concealing, or withholding facts may result
                 in paying the State agency, in cash, the value of the food benefits improperly issued to me and may subject
                 me to civil or criminal prosecution under State and Federal law. Standards for eligibility and participation
                 in the SFMNP are the same for everyone, regardless of race, color, national origin, age, disability,
                 or sex (including gender identity and sexual orientation), or reprisal or retaliation for prior civil rights activity.
                 I understand that I may appeal any decision made by the local agency regarding my eligibility for the SFMNP.
                <br/><a href="https://www.ecfr.gov/current/title-7/subtitle-B/chapter-II/subchapter-A/part-249" target="_blank">https://www.ecfr.gov/current/title-7/subtitle-B/chapter-II/subchapter-A/part-249</a>
                </p>

                <strong>Dual Participation</strong>
                <p>Please note that you are allowed to apply for Senior Farmers Market benefits only once per year within the state.
                    Applying multiple times in the same year or under a different name is illegal and may result in disqualification,
                    repayment of benefits, and/or civil or criminal prosecution under state or federal law.</p>

                <strong>Nondiscrimination Statement for Senior Farmers’ Market Nutrition Program</strong>
                <p>In accordance with Federal civil rights law and U.S. Department of Agriculture (USDA) civil rights
                    regulations and policies, the USDA, its Agencies, offices, and employees, and institutions participating
                    in or administering USDA programs are prohibited from discriminating based on race, color, national origin,
                    religion, sex, disability, age, marital status, family/parental status, income derived from a public assistance
                    program, political beliefs, or reprisal or retaliation for prior civil rights activity, in any program or
                    activity conducted or funded by USDA (not all bases apply to all programs). Remedies and complaint filing
                    deadlines vary by program or incident.</p>
                <p>Persons with disabilities who require alternative means of communication for program information (e.g., Braille,
                    large print, audiotape, American Sign Language, etc.) should contact the State or local Agency that administers
                    the program or contact USDA through the Telecommunications Relay Service at 711 (voice and TTY). Additionally,
                    program information may be made available in languages other than English.</p>
                <p>To file a program discrimination complaint, complete the USDA Program Discrimination Complaint Form, AD-3027,
                     found online at How to File a Program Discrimination Complaint and at any USDA office or write a letter
                     addressed to USDA and provide in the letter all of the information requested in the form. To request a
                     copy of the complaint form, call (866) 632-9992. Submit your completed form or letter to USDA
                     by: (1) mail: U.S. Department of Agriculture, Office of the Assistant Secretary for Civil Rights,
                     1400 Independence Avenue, SW, Mail Stop 9410, Washington, D.C. 20250-9410; (2) fax: (202) 690-7442;
                     or (3) email: <a href="mailto:program.intake@usda.gov">program.intake@usda.gov</a>.</p>
                <p>USDA is an equal opportunity provider, employer, and lender.</p>
                <form onSubmit={handleSubmit}>
                    <div className="form-group col-12">
                        <div className="form-check">
                            <label className='form-check-label' htmlFor="iAgree" style={{padding:'.1em'}}>
                            <input className="form-check-input" type="checkbox" value="true" id="iAgree" style={checkBoxStyle} required onInvalid={checkboxMessage} onChange={checkboxMessage} />
                            &nbsp;I understand and agree to the <strong>Participant Rights & Responsibility</strong> and <strong>Dual Participation</strong> statements defined above.
                            </label>
                        </div>
                    </div>
                <button className='btn btn-success' id='btnSubmit'>Submit Application</button>
                <span style={{display:'inline-block', margin:'.7em'}}>
                <MessageTag2 message={message2}/>
                </span>
                <br/>

                <button className="btn btn-primary" type='button' onClick={previousScreen} id="btnBack">Back To Review Application</button>
            </form>
        </div>
    } else if (screen == 4) {
        return <div className='container'>
            <h3>{applicantion.name}</h3>
            <h4 id="thankYou">Thank You</h4>
            <p>The application has been received.</p>
            <a href="">Add Another Application</a>
        </div>
    } else {
        return <div className='container'>
            <h3>{applicantion.name}</h3>
            <MessageTag message={message}/>
            <Processing show={showSpinner}/>
            <p>Sorry for the inconvenience.</p>
        </div>
    }
}
